/* ============================================================================
 * size-i18n.js — data for the market + language aware size-info line.
 *   dims:    poster + framed per MARKET (US/CA -> inches, else cm)  [numbers]
 *   t:       wording per LANGUAGE — recommend sentence per size + "framed" label
 *   formats: per-Format tweaks — noFrame (hide the framed part) + size overrides
 * Language picks the words; market picks the numbers. Fallback language = en.
 * NOTE: review the DE/FR/IT/ES wording to match your house style.
 * ==========================================================================*/
window.SIZE_I18N = {
  t: {
    en: { framed: "Framed approx.", recommend: {
      XS: "Perfect for desks, shelves, or as part of a gallery wall.",
      S:  "A versatile size for smaller walls and cosy corners.",
      M:  "A striking focal point for any room.",
      L:  "Made to impress above a sofa, bed, or dining table.",
      XL: "A bold statement piece for large walls and open spaces." } },
    de: { framed: "Gerahmt ca.", recommend: {
      XS: "Perfekt für Schreibtische, Regale oder als Teil einer Gallery Wall.",
      S:  "Ein vielseitiges Format für kleinere Wände und gemütliche Ecken.",
      M:  "Ein markanter Blickfang für jeden Raum.",
      L:  "Ein echter Hingucker über Sofa, Bett oder Esstisch.",
      XL: "Ein ausdrucksstarkes Statement für große Wände und offene Räume." } },
    fr: { framed: "Encadré env.", recommend: {
      XS: "Parfait sur un bureau, une étagère ou dans un mur de cadres.",
      S:  "Un format polyvalent pour les petits murs et les coins cosy.",
      M:  "Un point focal saisissant pour n'importe quelle pièce.",
      L:  "Fait forte impression au-dessus d'un canapé, d'un lit ou d'une table.",
      XL: "Une pièce affirmée pour les grands murs et les espaces ouverts." } },
    it: { framed: "Con cornice circa", recommend: {
      XS: "Perfetto su scrivanie, mensole o come parte di una gallery wall.",
      S:  "Un formato versatile per pareti piccole e angoli accoglienti.",
      M:  "Un punto focale d'effetto per qualsiasi stanza.",
      L:  "Fa un figurone sopra un divano, un letto o un tavolo da pranzo.",
      XL: "Un pezzo deciso per grandi pareti e spazi aperti." } },
    es: { framed: "Enmarcada aprox.", recommend: {
      XS: "Perfecta sobre escritorios, estanterías o como parte de una pared de cuadros.",
      S:  "Un tamaño versátil para paredes pequeñas y rincones acogedores.",
      M:  "Un punto focal llamativo para cualquier habitación.",
      L:  "Causa sensación sobre un sofá, una cama o una mesa de comedor.",
      XL: "Una pieza con carácter para paredes grandes y espacios abiertos." } }
  },
  dims: {
    EU: {
      XS: { poster: '21 × 30 cm',  framed: '24 × 33 cm' },
      S:  { poster: '30 × 40 cm',  framed: '33 × 43 cm' },
      M:  { poster: '50 × 70 cm',  framed: '53 × 73 cm' },
      L:  { poster: '61 × 91 cm',  framed: '64 × 94 cm' },
      XL: { poster: '70 × 100 cm', framed: '73 × 103 cm' }
    },
    US: {
      XS: { poster: '7 × 10"',  framed: '8.2 × 11.2"' },
      S:  { poster: '12 × 16"', framed: '13.2 × 17.2"' },
      M:  { poster: '18 × 24"', framed: '19.2 × 25.2"' },
      L:  { poster: '24 × 36"', framed: '25.2 × 37.2"' },
      XL: { poster: '28 × 40"', framed: '29.2 × 41.2"' }
    }
  },
  // Per-Format handling. Satin Canvas is a stretched canvas (no external frame),
  // so hide the "framed" part; and its L size is truly 60×90 cm (EU only — no US
  // canvas). Add more formats here if any ever need a size/frame exception.
  formats: {
    "Satin Canvas": { noFrame: true, overrides: { EU: { L: { poster: '60 × 90 cm' } } } }
  }
};